import { DH } from '../hooks';
import { round } from './utils';
var DEFAULT_INITIAL_PLAN_PADDING = 32;
export var getViewBoxString = function (_a) {
    var scale = _a.scale, container = _a.container, initialX = _a.x, initialY = _a.y;
    var _b = getScaledPannedViewBox({ scale: scale, container: container, x: initialX, y: initialY }), x = _b.x, y = _b.y, width = _b.width, height = _b.height;
    return "".concat(x, " ").concat(y, " ").concat(width, " ").concat(height);
};
export var getScaledPannedViewBox = function (_a) {
    var scale = _a.scale, container = _a.container, initialX = _a.x, initialY = _a.y;
    var _b = getScaledViewBox({ scale: scale, container: container }), centeringX = _b.centeringX, centeringY = _b.centeringY, width = _b.width, height = _b.height;
    var x = initialX - centeringX;
    var y = initialY - centeringY;
    return { x: x, y: y, width: width, height: height };
};
export var getScaledViewBox = function (_a) {
    var scale = _a.scale, container = _a.container, customCentering = _a.customCentering;
    var clientWidth = container.clientWidth, clientHeight = container.clientHeight;
    var width = clientWidth / scale;
    var height = clientHeight / scale;
    var deltaWidth = width - clientWidth;
    var deltaHeight = height - clientHeight;
    var centeringX = deltaWidth / 2;
    var centeringY = deltaHeight / 2;
    var deltaX = 0;
    var deltaY = 0;
    if (customCentering) {
        var oldScale = customCentering.oldScale, zoomPosition = customCentering.zoomPosition;
        var oldMidX = clientWidth / oldScale / 2;
        var oldMidY = clientHeight / oldScale / 2;
        var diffFromMidX = zoomPosition.x / oldScale - oldMidX;
        var diffFromMidY = zoomPosition.y / oldScale - oldMidY;
        deltaX += diffFromMidX;
        deltaY += diffFromMidY;
        var newDiffFromMidX = (diffFromMidX * oldScale) / scale;
        var newDiffFromMidY = (diffFromMidY * oldScale) / scale;
        deltaX -= newDiffFromMidX;
        deltaY -= newDiffFromMidY;
    }
    return {
        centeringX: centeringX,
        centeringY: centeringY,
        width: width,
        height: height,
        deltaX: deltaX,
        deltaY: deltaY,
    };
};
export var getFactualElementPosition = function (_a) {
    var _b;
    var element = _a.element, _c = _a.definition, definition = _c === void 0 ? null : _c, svgContainer = _a.svgContainer, svgViewBox = _a.svgViewBox, _d = _a.returnBoundingBox, returnBoundingBox = _d === void 0 ? false : _d, _e = _a.useMeasuringRectangle, useMeasuringRectangle = _e === void 0 ? false : _e;
    var svgContainerPosition = svgContainer.getBoundingClientRect();
    var _f = getScaledViewBox({
        scale: svgViewBox.scale,
        container: svgContainer,
    }), centeringX = _f.centeringX, centeringY = _f.centeringY;
    var measuringRect = useMeasuringRectangle
        ? (_b = element.querySelector("[data-hook=".concat(DH.SHAPE_MEASURING_RECT, "]"))) !== null && _b !== void 0 ? _b : element
        : element;
    var _g = measuringRect.getBoundingClientRect(), boundingX = _g.x, boundingY = _g.y, boundingWidth = _g.width, boundingHeight = _g.height;
    var scaledBoundingWidth = boundingWidth / svgViewBox.scale;
    var scaledBoundingHeight = boundingHeight / svgViewBox.scale;
    var midX = (boundingX - svgContainerPosition.x) / svgViewBox.scale +
        round(scaledBoundingWidth / 2) -
        centeringX +
        svgViewBox.x;
    var midY = (boundingY - svgContainerPosition.y) / svgViewBox.scale +
        round(scaledBoundingHeight / 2) -
        centeringY +
        svgViewBox.y;
    if (returnBoundingBox) {
        var scaledBoundingX = midX - round(scaledBoundingWidth / 2);
        var scaledBoundingY = midY - round(scaledBoundingHeight / 2);
        return {
            x: scaledBoundingX,
            y: scaledBoundingY,
            width: scaledBoundingWidth,
            height: scaledBoundingHeight,
        };
    }
    var x = midX - round(definition.width / 2);
    var y = midY - round(definition.height / 2);
    return { x: x, y: y, width: definition.width, height: definition.height };
};
export var elementApproximateBoundingRectangle = function (_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height, _b = _a.angle, angle = _b === void 0 ? 0 : _b;
    var apxWidth = Math.max(Math.abs(width * Math.cos(angle)), Math.abs(height * Math.sin(angle)));
    var apxHeight = Math.max(Math.abs(width * Math.sin(angle)), Math.abs(height * Math.cos(angle)));
    var apxX = x + (width - apxWidth) / 2;
    var apxY = y + (height - apxHeight) / 2;
    return { width: apxWidth, height: apxHeight, x: apxX, y: apxY };
};
export var getPlanBoundingRectangle = function (plan) {
    var elements = plan.sectors.flatMap(function (_a) {
        var el = _a.elements;
        return el;
    });
    var box = null;
    for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
        var config = elements_1[_i].config;
        var _a = elementApproximateBoundingRectangle(config), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        if (box === null) {
            box = { width: width, height: height, x: x, y: y };
            continue;
        }
        var maxX = box.x + box.width;
        var maxY = box.y + box.height;
        box.x = box.x > x ? x : box.x;
        box.y = box.y > y ? y : box.y;
        var shapeEndX = x + width;
        var shapeEndY = y + height;
        maxX = maxX < shapeEndX ? shapeEndX : maxX;
        maxY = maxY < shapeEndY ? shapeEndY : maxY;
        box.width = maxX - box.x;
        box.height = maxY - box.y;
    }
    return box;
};
export var getPlanViewBoxValues = function (_a) {
    var plan = _a.plan, container = _a.container, padding = _a.padding, forcedContainerDimensions = _a.forcedContainerDimensions;
    var planBox = getPlanBoundingRectangle(plan);
    var containerBox;
    if (forcedContainerDimensions) {
        containerBox = forcedContainerDimensions;
    }
    else if (container) {
        containerBox = container.getBoundingClientRect();
    }
    else {
        containerBox = planBox;
    }
    if (!planBox) {
        return { x: 0, y: 0, width: containerBox.width, height: containerBox.height };
    }
    var planRatio = planBox.width / planBox.height;
    var containerRatio = containerBox.width / containerBox.height;
    if (planRatio >= containerRatio) {
        var width = planBox.width;
        var height = (width * containerBox.height) / containerBox.width;
        var x = planBox.x;
        var y = -(height / 2 - planBox.height / 2) + planBox.y;
        var resizeRatio = containerBox.width / width;
        return addBoundingBoxPadding({ width: width, height: height, x: x, y: y }, true, padding / resizeRatio);
    }
    else {
        var height = planBox.height;
        var width = (height * containerBox.width) / containerBox.height;
        var y = planBox.y;
        var x = -(width / 2 - planBox.width / 2) + planBox.x;
        var resizeRatio = containerBox.height / height;
        return addBoundingBoxPadding({ width: width, height: height, x: x, y: y }, false, padding / resizeRatio);
    }
};
export var addBoundingBoxPadding = function (box, widthBasedSizing, padding) {
    if (widthBasedSizing) {
        var adjustedPadding = (padding * box.width) / (box.width - 2 * padding);
        var x = box.x - adjustedPadding;
        var width = box.width + adjustedPadding * 2;
        var height = (width * box.height) / box.width;
        var y = box.y - (height - box.height) / 2;
        return { x: x, y: y, width: width, height: height };
    }
    else {
        var adjustedPadding = (padding * box.height) / (box.height - 2 * padding);
        var y = box.y - adjustedPadding;
        var height = box.height + adjustedPadding * 2;
        var width = (height * box.width) / box.height;
        var x = box.x - (width - box.width) / 2;
        return { x: x, y: y, width: width, height: height };
    }
};
export var getInitialViewBox = function (_a) {
    var plan = _a.plan, container = _a.container, _b = _a.padding, padding = _b === void 0 ? DEFAULT_INITIAL_PLAN_PADDING : _b, forcedContainerDimensions = _a.forcedContainerDimensions;
    var _c = forcedContainerDimensions
        ? getPlanViewBoxValues({ plan: plan, forcedContainerDimensions: forcedContainerDimensions, padding: padding })
        : getPlanViewBoxValues({ plan: plan, container: container, padding: padding }), x = _c.x, y = _c.y, width = _c.width, height = _c.height;
    return "".concat(x, " ").concat(y, " ").concat(width, " ").concat(height);
};
//# sourceMappingURL=bounding-boxes.js.map